module.exports = __webpack_public_path__ + "source-sans-pro-v11-latin-italic-981d17e7c68609dcb88dce2c807a72e8.bundle.woff2";